module.exports = __webpack_public_path__ + "assets/user-36ce94cd7e1f3cf31812db704b8cb9d0.png";